<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" :destroy-on-close="true"
      :before-close="cancel">
     <div class="el-dialog-div">
        <el-form label-width="90px" ref="form" :model="form">
          <div style="width: 100%">
            <div style="display: flex;align-items: center" v-for="(paymentInfo, index) in form.paymentInfos">
              <div style="display: flex;flex-wrap:wrap;width: 97%;" class="payment-box">
                <el-form-item :label="['add', 'batch'].includes(type) ? '付款单位' : '客户单位'"
                  :prop="'paymentInfos.' + index + '.invoiceTitle'"
                  :rules="{ required: true, message: '请输入客户单位', trigger: 'change' }">
                  <el-input v-model="paymentInfo.invoiceTitle" placeholder="请输入客户单位"
                    :disabled="type === 'delete' || tabClassify !== 'claim' || paymentInfo['claimTheInvoiceFlag']"></el-input>
                </el-form-item>
                <el-form-item label="收款单位" :prop="'paymentInfos.' + index + '.receivingUnitId'"
                  :rules="{ required: true, message: '请输入收款单位', trigger: 'change' }">
                  <el-select v-model="paymentInfo.receivingUnitId" style="width: 100%!important;" filterable
                    placeholder="请输入收款单位"
                    :disabled="type === 'delete' || tabClassify !== 'claim' || paymentInfo['claimTheInvoiceFlag']">
                    <el-option v-for="(item, index) in businessOption" :key="index" :label="item.companyName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发票号码" required>
                  <el-input v-model="paymentInfo.invoiceNumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="发票金额" v-if="['add', 'edit'].includes(type)">
                  <el-input v-model="paymentInfo.invoiceAmount" disabled></el-input>
                </el-form-item>
                <el-form-item label="到款金额" :prop="'paymentInfos.' + index + '.paymentAmount'" :rules="[{ required: true, message: '请输入到款金额', trigger: 'change' },
                { validator: checkNum, trigger: 'change' }]">
                  <el-input v-model="paymentInfo.paymentAmount"
                    :disabled="type === 'delete' || paymentInfo['claimTheInvoiceFlag']"
                    placeholder="请输入到款金额"></el-input>
                </el-form-item>
                <el-form-item label="到款日期" :prop="'paymentInfos.' + index + '.paymentDate'" :rules="[
                  { required: true, message: '请选择到款时间', trigger: 'change' },
                  { validator: checkDate, trigger: 'change' }]">
                  <el-input size="medium" v-model="paymentInfo.paymentDate" auto-complete="off"
                    :disabled="type === 'delete' || paymentInfo['claimTheInvoiceFlag']"
                    placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                </el-form-item>
                <el-form-item label="到款备注" :prop="'paymentInfos.' + index + '.remark'" style="width: 95%!important;">
                  <el-input :autosize="{ minRows: 3 }" type="textarea" maxlength="300" show-word-limit
                    :disabled="type === 'delete' || paymentInfo['claimTheInvoiceFlag']" v-model="paymentInfo.remark"
                    placeholder="请输入备注"></el-input>
                </el-form-item>
              </div>

              <div v-if="type === 'batch'"
                style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(index)"
                  style="margin-bottom: 2px;"></el-button>
                <el-button v-if="index === form.paymentInfos.length - 1" type="success" size="mini"
                  style="margin: 1px 0 0;" icon="el-icon-plus" @click="handleAdd"></el-button>
              </div>
              <el-button v-if="type === 'delete'" type="danger" size="mini" icon="el-icon-delete"
                @click="handleDeletePayment(paymentInfo)">删除到款</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="type !== 'delete'">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="dataLoading" load-text="数据加载中"></loading>
  </div>
</template>

<script>
import {addPayment, editPayment} from "@/api/dilivery/payment";
import {checkDate, checkNum} from "@/utils/rules";
import {padDate} from "@/store/date";
import {getCompanyPage} from "@/api/dilivery/company";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { deletePayment } from "@/api/dilivery/payment";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddPayment",
  components: {
    Loading
  },
  props:['showDialog','selectDetail','tabClassify','Info','type'],
  data(){
    return{
      role:'',
      title:'添加到款信息',
      dataLoading: false,
      form:{
        paymentInfos:[],
      },
      businessOption:[],
    }
  },
  created(){
    this.role = getDataInLocalStorage('role')
  },
  watch:{
    type:{
      handler(newVal){
        if(newVal){
          if(newVal === 'add'){
            this.title = '添加到款信息'
          }else if(newVal === 'batch'){
            this.title = '批量添加到款信息'
          }else if (newVal === 'delete') {
            this.title = '删除到款信息'
          }else{
            this.title = '编辑到款信息'
          }
        }
      },
      immediate:true
    }
  },
  mounted() {
    this.dataLoading = true
    if(this.type === 'add'){
      this.selectDetail.forEach((_,index)=>{
        this.handleAdd(index)
      })
    } else if (['edit', 'delete'].includes(this.type)){
      this.form.paymentInfos = this.Info['payments']? this.Info['payments'].filter(item => item.paymentStatus === 'DONE').map(item => {
        return {
          ...item,
          invoiceNumber:this.Info.invoiceNumber,
          invoiceAmount:this.Info.invoiceAmount
        }}):[]
    }else {
      this.handleAdd()
    }
    this.getBusinessOption()
  },
  methods:{
    checkNum,
    checkDate,
    handleDeletePayment (row) {
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          "ids": row.id
        }
        deletePayment(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.$emit('submit', 'confirm')
          }
        }).catch(err => {
        })
      }).catch(() => { })
    },
    handleAdd(index=0) {
      let form = {
        invoiceTitle: this.selectDetail?.[index]?.invoiceTitle,
        receivingUnitId:this.selectDetail?.[index]?.billingUnit?.id,
        paymentAmount:this.selectDetail?.[index]?.invoiceAmount,
        paymentDate: '',
        invoiceId:this.selectDetail?.[index]?.id,
        invoiceNumber:this.selectDetail?.[index]?.invoiceNumber?this.selectDetail?.[index]?.invoiceNumber:'暂不认领',
        invoiceAmount:this.selectDetail?.[index]?.invoiceAmount,
        remark:''
      }
      form.paymentDate = this.getCurrentDate()
      this.form.paymentInfos.push(form)
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      return `${year}-${month}-${day}`
    },
    getBusinessOption() {
      try {
        let params = {
          'page.current': 1,
          'page.size': 500,
          'order': 'id.asc'
        }
        getCompanyPage(params, {}).then(res => {
          if (res.code === 200) {
            this.businessOption = res.data.records
          }
        }).finally(() => {
          this.dataLoading = false
        })
      } catch (error) {
        console.log(error);
        this.dataLoading = false
      }
    },
    handleDelete(index) {
      this.form.paymentInfos.splice(index, 1);
      if(this.form.paymentInfos.length<=0 || !Array.isArray(this.form.paymentInfos)){
        let form = {
          invoiceTitle: '',
          paymentAmount:'',
          paymentDate: '',
          invoiceId:'',
          remark:''
        }
        form.paymentDate = this.getCurrentDate()
        this.form.paymentInfos = [form]
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle() {
      if(this.form.paymentInfos.length!==0){
        this.$refs.form.validate(valid=>{
          if(valid){
            this.form.paymentInfos.forEach(item=>{
              item.paymentDate = padDate(item.paymentDate)
            })
            if(this.type === 'edit'){
              editPayment(this.form.paymentInfos).then(res => {
                if (res.code === 200) {
                  this.$emit('submit','confirm')
                  this.$messageUi.success('修改成功')
                }
              }).catch(err => {
              })
            }else{
              addPayment(this.form.paymentInfos).then(res => {
                if (res.code === 200) {
                  this.$emit('submit','confirm')
                  this.$messageUi.success('提交成功')
                }
              }).catch(err => {
              })
            }
          }else{
            this.$nextTick(() => {
              let err = document.getElementsByClassName('is-error')
              if (err.length) {
                err[0].scrollIntoView({
                  block: 'center',
                  behavior: 'smooth',
                })
              }
            })
            this.$messageUi.error('填写参数不规范，请检查')
          }
        })
      }else{
        this.$messageUi.error('请上传至少一条数据')
      }
    }
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}
.payment-box {
  border: 1px dashed #ccc;
  /* 虚线框 */
  padding: 10px 10px 0 10px;
  /* 内边距 */
  margin: 10px 10px 0 0;
}

.payment-box:deep(.el-form-item) {
  width: 48% !important;
}
</style>